import './borrower_date_fields.scss'
import {Borrower} from "../../../customers/model/Borrower";
import {IScope} from "angular";
import {CustomerInfoOptions} from "../../model/CustomerInfoOptions";

interface CustomerDateFieldsScope extends IScope {
    selectedContact: Borrower;
    options: CustomerInfoOptions;
}

export class BorrowerDateFields {

    static instance = {
        controller: ['$scope', BorrowerDateFields],
        template: require('./borrower_date_fields.html'),
        bindings: {
            "customer": "<",
            "options": "<"
        }
    }

    private customer: Borrower;
    private selectedId: number;
    private options: CustomerInfoOptions;

    constructor(private $scope: CustomerDateFieldsScope) {
    }


    $onInit() {
        this.$scope.selectedContact = this.customer;
        this.selectedId = this.customer.id;
        this.initOptions();
    }


    private initOptions() {
        this.options = this.options || {
            readonly: false
        }
        this.$scope.options = this.options;
    }
}